export default "__VITE_ASSET__f38e2b4d__"